export function AgentManagerIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none" {...props}>
      <g clipPath="url(#clip0_144_5539)">
        <path d="M10 11.1611L9 10.1611" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.33317 12.4717L7.6665 11.8279" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.99995 5.82782L6.74615 7.58075C6.31986 7.91235 5.71337 7.87455 5.33148 7.49268C4.95114 7.11235 4.91195 6.50888 5.23991 6.08254L7.46728 3.18695C7.79075 2.76642 8.33282 2.5777 8.84748 2.70637L11.9999 3.49449H15.3333V9.49448H13.9999" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.33317 6.49471L10.9988 8.71611C11.6722 9.27724 11.6302 10.3242 10.9142 10.8297L7.50924 13.2332C7.01297 13.5834 6.34274 13.5541 5.87906 13.1617L2.33317 10.1614H0.666504V4.16138H3.33317" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_144_5539">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
